/* eslint 'no-useless-concat':'off','no-useless-constructor':'off' */
import React, { Component } from 'react';
import { Col, Button, FormGroup } from 'reactstrap';
import '../../../../../Assets/EnsembleStyles/ChangeLimits.css';

export default class AdditionalDeleteConfirmation extends Component {
    constructor(props){
        super(props);
    }
    

    render() {
        var	Delete	=	this.props.Delete;
        return (
            <div className="ChangeLimits_Modal">
                <h4 className="Modal_form_title">  {this.props.parentToChildData[0]}</h4>
                <p  className="error_msg">
                {this.props.parentToChildData[1]}
                <br/>
                <br/>
                <br/>
                <input type="checkbox" className="AvailZones_header_Check_box1" />{this.props.parentToChildData[2]} 
                </p> 
                  
                    <FormGroup row >
                        <Col sm={{ size: 12 }}>
                            <Button className="btn-success btn-md ChangeLimits_Applybtn"   onClick={() => Delete('yes'+',AvailZones_header_Check_box1')}> Yes </Button>
                            <Button className="btn-gray btn-md ChangeLimits_Cancelbtn"   onClick={() => Delete('Cancel')}>Cancel</Button>
                        </Col>
                    </FormGroup>
            </div>
        );
    }
}



